import type { ReactNode } from 'react'
import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons'
import { Icon, Text } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'

export const Shell = ({ children }: { children: ReactNode }) => (
  <div className="mt-2 flex flex-col gap-3 rounded-[16px] border border-neutral-200 bg-neutral-0 p-4 shadow-sm">
    {children}
  </div>
)

export const BUTTON_ROW = 'flex flex-wrap items-center gap-2'

export const CardIcon = ({ icon }: { icon: IconProp }) => (
  <Icon
    icon={icon}
    color="text-moss-200"
    backgroundStyle="rounded"
    backgroundClassName="size-8 shrink-0 bg-moss-25"
  />
)

export const QuestionHeading = ({
  children,
  subtitle,
}: {
  children: string
  subtitle?: string
}) => (
  <div className="flex items-start gap-3">
    <CardIcon icon={faCircleQuestion} />
    <div className="flex flex-col gap-0.5 pt-1.5">
      <Text variant={TypographyStyles.LABEL_MD} color={TextColors.HEADER}>
        {children}
      </Text>
      {subtitle && (
        <Text variant={TypographyStyles.BODY_SM} color={TextColors.MUTED}>
          {subtitle}
        </Text>
      )}
    </div>
  </div>
)
